<template>
  <v-dialog v-model="edit_modal" max-width="1312" persistent content-class="elevation-0">
    <v-card :loading="loading" max-width="1300" class="mb-5 mr-5">
      <v-card-title>
        <v-col cols="2">{{(is_view_mode)?'Project Details':'Edit Project'}}</v-col>
        <v-col cols="8" class="align-right"></v-col>
        <v-col cols="2" class v-if="disable_project_work_radio">
          <v-card-subtitle
            class="custome-label-font pa-2 ma-0 pl-1 text-center"
          >{{form_data.project_work=='new_construction' ? 'New Construction' : form_data.project_work=='remodeling' ? 'Remodeling' : form_data.project_work=='retail_sales' ? 'General Invoice' : form_data.project_work=='counter_tops' ? 'Counter Tops' : '' }}</v-card-subtitle>
          <v-card-text
            class="primary text-center white--text custome-value-font pa-0 ma-0 pt-1 pb-1 pl-1"
          >
            <span
              v-if="form_data.total_new_con > 0 || form_data.total_remodeling > 0 || form_data.total_retail_sale > 0 || form_data.total_countertop  > 0 "
            >${{(overhand_project_work_value)}}</span>
            <p class="mb-3" v-else></p>
          </v-card-text>
        </v-col>
      </v-card-title>
      <v-card-text>
        <v-form :readonly="is_view_mode">
          <v-row dense class="mb-2 grey lighten-2 pt-2 pb-1">
            <v-col cols="1" style="max-width: 10%;">
              <v-text-field
                label="Order No"
                dense
                v-model="form_data.project_id"
                hide-details
                readonly
                placeholder=" "
              ></v-text-field>
              {{form_data.actual_created_date}}
            </v-col>
            <v-col cols="2" style="max-width: 17%;">
              <v-menu
                v-model="display_date"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="form_data.display_date"
                    label="Order Date"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                    dense
                    hint="MM/DD/YYYY format"
                    placeholder=" "
                    :error-messages="form_error.display_date"
                    :hide-details="!form_error.display_date"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="dateFormattedDisplay"
                  @input="display_date = false; parseDateDisplay()"
                  no-title
                  scrollable
                ></v-date-picker>
              </v-menu>
            </v-col>

            <v-col cols="2" style="max-width: 14%;">
              <v-menu
                v-model="estimated_completed_date"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="form_data.estimated_completed_date"
                    label="Est. Comp. Dt"
                    v-bind="attrs"
                    v-on="on"
                    dense
                    :error-messages="form_error.estimated_completed_date"
                    :hide-details="!form_error.estimated_completed_date"
                    placeholder=" "
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="dateFormatted"
                  @input="estimated_completed_date = false; parseDate()"
                  no-title
                  scrollable
                ></v-date-picker>
              </v-menu>
            </v-col>
            <v-col
              cols="2"
              style="max-width: 14%;"
              v-if="form_data.project_work=='new_construction' || form_data.project_work=='remodeling'"
            >
              <v-text-field
                label="R.Comp.Dt"
                dense
                v-model="form_data.revised_completion_date"
                hide-details
                readonly
                placeholder=" "
              ></v-text-field>
            </v-col>
            <v-col style="max-width: 12%;">
              <v-select
                :items="order_types"
                label="Status"
                dense
                v-model="form_data.order_type"
                :error-messages="form_error.order_type"
                :hide-details="!form_error.order_type"
                placeholder=" "
                @change="changeStatus(form_data.order_type)"
              ></v-select>
              <!-- <v-radio-group
                v-model="form_data.order_type"
                row
                hide-details
                class="mt-0"
                dense=""
              >
                <v-radio
                  label="Estimate"
                  value="2"
                  class="ma-0 pa-0 pl-1"
                ></v-radio>
                <v-radio
                  label="Order"
                  value="1"
                  class="ma-0 pa-0"
                ></v-radio>
              </v-radio-group>-->
            </v-col>
            <v-col style="max-width: 12%;">
              <!-- <v-text-field
                label="Order Amount"
                dense=""
                v-model="form_data.transactoin_amount"
                :error-messages="form_error.transactoin_amount"
                :hide-details="!form_error.transactoin_amount"
                readonly=""
                placeholder=" "
              ></v-text-field>-->
              <v-text-field
                label="Order Amount"
                dense
                v-model="overhand_project_work_value"
                readonly
                placeholder=" "
              ></v-text-field>
            </v-col>
            <v-col style="max-width: 12%;">
              <v-select
                :items="p_type"
                label="Order Type"
                dense
                v-model="form_data.p_type"
                :error-messages="form_error.p_type"
                :hide-details="!form_error.p_type"
                placeholder=" "
                :disabled="form_data.project_work=='project_management' || form_data.invoices_count > 0 || ((form_data.change_order_list) > 0) || form_data.assign_group > 0 "
              ></v-select>
            </v-col>
            <v-col style="max-width: 12%;">
              <v-text-field
                label="Overhead & Profit %"
                dense
                type="number"
                v-model="form_data.p_price"
                :error-messages="form_error.p_price"
                :hide-details="!form_error.p_price"
                placeholder=" "
                :disabled="form_data.p_lock || form_data.order_confirmed"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row dense class="mb-0">
            <v-col cols="5">
              <v-autocomplete
                dense
                label="Customer"
                v-model="form_data.customer_id"
                :items="customer_list"
                :error-messages="form_error.customer_id"
                :hide-details="!form_error.customer_id"
                item-text="full_name"
                item-value="customer_id"
                @change="changeCustomer()"
                :disabled="form_data.p_lock"
              >
                <template v-slot:no-data>
                  <div class="d-flex align-center">
                    <span
                      class="pl-2"
                      style="
                          font-size: 0.8125rem;
                          font-weight: 500;
                          line-height: 1rem;
                        "
                    >No Customer Found!</span>
                    <span
                      @click="addCustomer"
                      class="mdi mdi-plus-circle pl-1 pr-2"
                      style="
                          font-size: 1.5rem;
                          cursor: pointer;
                          color: #6e9a35 !important;
                        "
                    ></span>
                  </div>
                </template>
              </v-autocomplete>
            </v-col>
            <v-col cols="1">
              <v-text-field
                v-model="form_data.multiplier"
                label="Multiplier"
                dense
                hide-details
                :disabled="form_data.p_lock || form_data.order_confirmed"
              ></v-text-field>
            </v-col>
            <v-col cols="1" class="less-space"></v-col>
            <v-col cols="3">
              <v-text-field
                label="Project name"
                dense
                v-model="form_data.p_name"
                :error-messages="form_error.p_name"
                :hide-details="!form_error.p_name"
              ></v-text-field>
            </v-col>

            <v-col class="d-flex justify-end">
              <label class="v-label theme--light mt-3 mr-2">{{lockName}}</label>
              <v-switch
                v-model="form_data.p_lock"
                label
                color="success"
                hide-details
                class="mt-1"
                dense
                :disabled="locked==true"
              ></v-switch>
              <span
                :class="form_data.p_lock ? 'mdi mdi-lock lock-red' : 'mdi mdi-lock-open lock-green'"
              ></span>
            </v-col>
            <v-col class="d-flex justify-end">
              <label class="v-label theme--light mt-3 mr-2">Active</label>
              <v-switch
                v-model="form_data.p_active"
                label
                color="success"
                hide-details
                class="mt-1"
                dense
              ></v-switch>
            </v-col>
          </v-row>
          <v-row dense class="mb-0">
            <v-col cols="2">
              <v-autocomplete
                label="Zip"
                dense
                v-model="form_data.p_zip"
                :error-messages="form_error.p_zip"
                :search-input.sync="zip_search"
                :items="zip_items"
                :hide-details="!form_error.p_zip"
                v-debounce:500="fetchZipCodes"
                :loading="zip_loading"
                :menu-props="{closeOnContentClick:true}"
              >
                <template v-slot:no-data v-if="zip_search">
                  <div class="d-flex align-center">
                    <span
                      class="pl-2"
                      style="font-size: 0.8125rem;font-weight: 500;line-height: 1rem;"
                    >No Zip Found!</span>
                    <span
                      @click="addZip"
                      class="mdi mdi-plus-circle pl-1 pr-2"
                      style="font-size: 1.50rem;cursor: pointer;color: #6e9a35 !important;"
                    ></span>
                  </div>
                </template>
              </v-autocomplete>
            </v-col>
            <v-col cols="1">
              <v-select
                :items="state_list"
                label="State"
                dense
                v-model="form_data.p_state"
                @change="getCity()"
                hide-details
              >
                <template v-slot:selection="{ item }">
                  <span>{{ item.short_name }}</span>
                </template>
              </v-select>
            </v-col>
            <v-col cols="3">
              <v-autocomplete
                :items="cities"
                label="City"
                dense
                v-model="form_data.p_city"
                class="capitalize-first-letter"
                @change="changeCity()"
                hide-details
                :search-input.sync="city_search"
                :menu-props="{closeOnContentClick:true}"
              >
                <template v-slot:no-data v-if="city_search">
                  <div class="d-flex align-center">
                    <span
                      class="pl-2"
                      style="font-size: 0.8125rem;font-weight: 500;line-height: 1rem;"
                    >No City Found!</span>
                    <span
                      @click="addCity"
                      class="mdi mdi-plus-circle pl-1 pr-2"
                      style="font-size: 1.50rem;cursor: pointer;color: #6e9a35 !important;"
                    ></span>
                  </div>
                </template>
              </v-autocomplete>
            </v-col>
            <v-col cols="1" class="less-space"></v-col>
            <v-col cols="2">
              <v-text-field
                label="Mobile"
                dense
                v-model="form_data.mobile"
                :error-messages="form_error.mobile"
                :hide-details="!form_error.mobile"
                v-mask="'(###)-###-####'"
              ></v-text-field>
            </v-col>
            <v-col cols="1">
              <v-text-field
                label="Short Code"
                dense
                v-model="form_data.p_code"
                v-mask="'XXXXXXX'"
                :error-messages="form_error.p_code"
                :hide-details="!form_error.p_code"
                class="capitalize-whole-letter"
              ></v-text-field>
            </v-col>
            <v-col cols="2" v-if="form_data.is_retainage" style="max-width: 9%;margin-left:30px;">
              <v-text-field
                label="Retainage %"
                dense
                v-model="form_data.retainage_percentage"
                :error-messages="form_error.retainage_percentage"
                :hide-details="!form_error.retainage_percentage"
                type="number"
                :disabled="form_data.invoices_count > 0"
              ></v-text-field>
            </v-col>
            <v-col class="d-flex justify-end">
              <label class="v-label theme--light mt-3 mr-2">Retainage</label>
              <v-switch
                v-model="form_data.is_retainage"
                label
                color="success"
                hide-details
                class="mt-1"
                dense
                :disabled="form_data.invoices_count > 0"
              ></v-switch>
            </v-col>
          </v-row>
          <v-row dense class="mb-0">
            <v-col cols="6">
              <v-text-field
                label="Street Address(Project Address)"
                class="capitalize-first-letter"
                dense
                v-model="form_data.p_address_1"
                :error-messages="form_error.p_address_1"
                :hide-details="!form_error.p_address_1"
              ></v-text-field>
            </v-col>
            <v-col cols="1" class="less-space"></v-col>
            <v-col cols="2">
              <v-text-field
                label="Office"
                dense
                v-model="form_data.work_phone"
                :error-messages="form_error.work_phone"
                :hide-details="!form_error.work_phone"
                v-mask="'(###)-###-####'"
              ></v-text-field>
            </v-col>
            <v-col cols="3" style="max-width: 20%;" class="d-flex justify-end">
              <label class="v-label theme--light mt-3 mr-2">Order Confirmed</label>
              <v-switch
                v-model="form_data.order_confirmed"
                label
                color="success"
                hide-details
                class="mt-1"
                dense
                :disabled="locked==true"
              ></v-switch>
            </v-col>
            <v-col class="d-flex justify-end">
              <label class="v-label theme--light mt-3 mr-2">Text Alert</label>
              <v-switch
                v-model="form_data.text_alert"
                label
                color="success"
                hide-details
                class="mt-1"
                dense
              ></v-switch>
            </v-col>
          </v-row>
          <v-row dense class="mb-0">
            <v-col cols="6">
              <v-text-field
                label="Street Address(Project Address)"
                class="capitalize-first-letter"
                dense
                v-model="form_data.p_address_2"
                :error-messages="form_error.p_address_2"
                :hide-details="!form_error.p_address_2"
              ></v-text-field>
            </v-col>
            <v-col cols="1" class="less-space"></v-col>
            <v-col cols="2">
              <v-text-field
                label="Fax"
                dense
                v-model="form_data.work_fax"
                :error-messages="form_error.work_fax"
                :hide-details="!form_error.work_fax"
                v-mask="'(###)-###-####'"
              ></v-text-field>
            </v-col>
            <v-col cols="3" style="max-width: 20%;" class="d-flex justify-end">
              <!-- <label class="v-label theme--light mt-3">Report</label>
              <v-switch
                v-model="form_data.project_for_report"
                label
                color="success"
                hide-details
                class="mt-1"
                dense
              ></v-switch>-->

              <label class="v-label theme--light mt-3">Profit & Loss</label>
              <v-switch
                v-model="form_data.profit_loss"
                label
                color="success"
                hide-details
                class="mt-1"
                dense
              ></v-switch>
            </v-col>
            <v-col class="d-flex justify-end">
              <label class="v-label theme--light mt-3 mr-2">Email Alert</label>
              <v-switch
                v-model="form_data.email_alert"
                label
                color="success"
                hide-details
                class="mt-1"
                dense
              ></v-switch>
            </v-col>
          </v-row>

          <v-row dense class="mb-0">
            <v-col cols="3">
              <v-text-field
                label="Bill To"
                class="capitalize-first-letter"
                dense
                v-model="form_data.bill_to"
                :error-messages="form_error.bill_to"
                :hide-details="!form_error.bill_to"
                loading
              >
                <template v-slot:progress>
                  <v-progress-linear value="100" absolute height="2" class="primary"></v-progress-linear>
                </template>
              </v-text-field>
            </v-col>
            <v-col cols="3">
              <v-checkbox
                dense
                hide-details
                v-model="is_same_address"
                label="Same as above address"
                class="pa-0 ma-0 mt-1"
                @change="sameAsAbove()"
              ></v-checkbox>
            </v-col>
            <v-col cols="1" class="less-space"></v-col>
            <v-col cols="2">
              <v-text-field
                label="Email"
                dense
                v-model="form_data.bill_to_email"
                :error-messages="form_error.bill_to_email"
                :hide-details="!form_error.bill_to_email"
                reverse
              ></v-text-field>
            </v-col>
            <v-col>
              <v-autocomplete
                prepend-icon="mdi-at"
                :items="domain_list"
                label="Domain"
                dense
                v-model="form_data.bill_to_email_domain"
                :error-messages="form_error.bill_to_email_domain"
                :hide-details="!form_error.bill_to_email_domain"
                :search-input.sync="domain_search"
                :menu-props="{closeOnContentClick:true}"
              >
                <template v-slot:no-data>
                  <div class="d-flex align-center">
                    <span
                      class="pl-2"
                      style="font-size: 0.8125rem;font-weight: 500;line-height: 1rem;"
                    >No Domain Found!</span>
                    <span
                      @click="addDomain"
                      class="mdi mdi-plus-circle pl-1 pr-2"
                      style="font-size: 1.50rem;cursor: pointer;color: #6e9a35 !important;"
                    ></span>
                  </div>
                </template>
              </v-autocomplete>
            </v-col>
          </v-row>

          <v-row dense class="mb-0">
            <v-col cols="2">
              <v-autocomplete
                label="Zip"
                dense
                v-model="form_data.bill_to_zip"
                :error-messages="form_error.bill_to_zip"
                :search-input.sync="bill_zip_search"
                :items="bill_zip_items"
                :hide-details="!form_error.bill_to_zip"
                v-debounce:500="fetchBZipCodes"
                :loading="bill_zip_loading"
                :menu-props="{closeOnContentClick:true}"
              >
                <template v-slot:no-data v-if="bill_zip_search">
                  <div class="d-flex align-center">
                    <span
                      class="pl-2"
                      style="font-size: 0.8125rem;font-weight: 500;line-height: 1rem;"
                    >No Zip Found!</span>
                    <span
                      @click="addZip2"
                      class="mdi mdi-plus-circle pl-1 pr-2"
                      style="font-size: 1.50rem;cursor: pointer;color: #6e9a35 !important;"
                    ></span>
                  </div>
                </template>
              </v-autocomplete>
            </v-col>
            <v-col cols="1">
              <v-select
                :items="state_list"
                label="State"
                dense
                v-model="form_data.bill_to_state"
                @change="getCity2()"
                hide-details
              >
                <template v-slot:selection="{ item }">
                  <span>{{ item.short_name }}</span>
                </template>
              </v-select>
            </v-col>
            <v-col cols="3">
              <v-autocomplete
                :items="bill_cities"
                label="City"
                dense
                v-model="form_data.bill_to_city"
                @change="changeCity2()"
                class="capitalize-first-letter"
                hide-details
                :search-input.sync="bill_to_city_search"
                :menu-props="{closeOnContentClick:true}"
              >
                <template v-slot:no-data v-if="bill_to_city_search">
                  <div class="d-flex align-center">
                    <span
                      class="pl-2"
                      style="font-size: 0.8125rem;font-weight: 500;line-height: 1rem;"
                    >No City Found!</span>
                    <span
                      @click="addCity2"
                      class="mdi mdi-plus-circle pl-1 pr-2"
                      style="font-size: 1.50rem;cursor: pointer;color: #6e9a35 !important;"
                    ></span>
                  </div>
                </template>
              </v-autocomplete>
            </v-col>
            <v-col cols="1" class="less-space"></v-col>
            <v-col cols="4" class="mt-0 pt-0 mb-0 pb-0">
              <v-text-field
                label="Architect Name"
                class="capitalize-first-letter"
                dense
                v-model="form_data.architect_name"
                :error-messages="form_error.architect_name"
                :hide-details="!form_error.architect_name"
              ></v-text-field>
            </v-col>
          </v-row>

          <v-row dense class="mb-0">
            <v-col cols="6">
              <v-text-field
                label="Street Address"
                class="capitalize-first-letter"
                dense
                v-model="form_data.bill_to_address_1"
                :error-messages="form_error.bill_to_address_1"
                :hide-details="!form_error.bill_to_address_1"
              ></v-text-field>
            </v-col>
            <v-col cols="1" class="less-space"></v-col>
          </v-row>
          <v-row dense class="mb-0">
            <v-col cols="6">
              <v-text-field
                label="Street Address"
                class="capitalize-first-letter"
                dense
                v-model="form_data.bill_to_address_2"
                :error-messages="form_error.bill_to_address_2"
                :hide-details="!form_error.bill_to_address_2"
              ></v-text-field>
            </v-col>
            <v-col cols="1" class="less-space"></v-col>
            <v-col cols="5" class="mt-0 pt-0 mb-0 pb-0">
              <v-row dense>
                <v-col cols="5" class="mt-0 pt-0 mb-0 pb-0"></v-col>
              </v-row>
            </v-col>
          </v-row>
          <v-row dense class="mb-0">
            <v-col cols="1">
              <v-text-field
                label="MMS Code"
                dense
                v-model="form_data.mms_code"
                :error-messages="form_error.mms_code"
                :hide-details="!form_error.mms_code"
              ></v-text-field>
            </v-col>
            <v-col cols="5">
              <v-text-field
                v-model="form_data.new_keywords"
                label="Keywords (comma sperated)"
                dense
                :error-messages="form_error.new_keywords"
                :hide-details="!form_error.new_keywords"
              >
                <template v-slot:prepend>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon
                        size="22"
                        v-bind="attrs"
                        v-on="on"
                        @click="keyword_dialog = true"
                      >mdi-eye-outline</v-icon>
                    </template>
                    <span>View Exist Keyword</span>
                  </v-tooltip>
                </template>
              </v-text-field>
            </v-col>
            <v-col cols="1" class="less-space"></v-col>
            <v-col cols="6" class="mt-0 pt-0 mb-0 pb-0" style="max-width: 47%;">
              <v-row dense></v-row>
            </v-col>
          </v-row>
          <v-row dense class="mb-0">
            <v-col cols="6"></v-col>
            <v-col cols="1" class="less-space"></v-col>
            <v-col cols="1"></v-col>
            <v-col cols="2" class="mt-0 pt-0 mb-0 pb-0">
              <v-card class="pa-0 ma-0" rounded="0" flat>
                <v-row dense></v-row>
              </v-card>
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>
      <v-card-actions class="pa-0" v-if="is_view_mode">
        <v-btn fab color="error" x-small absolute @click="closePopup()" class="custom-close-btn">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-actions>
      <v-card-actions v-else>
        <v-btn color="error" @click="closePopup()" :disabled="loading">Cancel</v-btn>
        <v-spacer></v-spacer>
        <v-btn v-if="!is_view_mode" color="primary" @click="saveProject()" :loading="loading">Save</v-btn>
      </v-card-actions>
    </v-card>
    <v-dialog v-model="keyword_dialog" max-width="350" persistent>
      <v-card class="mx-auto align-self-stretch" tile :loading="keyword_loading" width="100%">
        <v-card-title class="headline pa-2">Keyword(s)</v-card-title>
        <v-card-text class="pa-2 pt-0" style="font-weight: 500;">
          <v-row
            dense
            v-if="form_data.keywords && form_data.keywords.length > 0"
            class="light-green lighten-4 primary--text"
          >
            <v-col
              cols="12"
              class="pt-2"
              v-for="(keyword, index) in form_data.keywords"
              :key="index"
            >
              <v-btn
                class="mx-2"
                fab
                dark
                x-small
                width="22"
                height="22"
                color="primary"
                @click="deleteKeyword(keyword)"
              >
                <v-icon small>mdi-close</v-icon>
              </v-btn>
              <span class="ml-2">{{ keyword.title }}</span>
              <!-- <v-chip
                class="ma-1"
                close
                color="primary"
                v-for="keyword in form_data.keywords"
                :key="keyword.keyword_id"
                @click:close="deleteKeyword(keyword)"
              >
                {{ keyword.title }}
              </v-chip>-->
            </v-col>
          </v-row>
          <v-row dense v-else>
            <v-col cols="12">No Any Eixst Keyword!</v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-btn color="error" dark @click="keyword_dialog = false">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="overhand_confirm" max-width="350" persistent>
      <v-card>
        <v-card-title class="headline">Confirmation</v-card-title>
        <v-card-text style="font-weight: 500;">
          <!-- <b> Are you sure you want to change Overhand & Profit  from {{exist_overhandvalue}} %  to {{form_data.p_price}} % ? </b> -->
          <b>
            Your Order amount will change from
            <br />
            ${{parseFloat(overhand_project_work_value).toFixed(2)}} to ${{parseFloat(next_overhand_project_work_value).toFixed(2)}}
          </b>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="error"
            @click="overhand_confirm = false;form_data.p_price=exist_overhandvalue;"
          >Cancel</v-btn>
          <v-btn color="primary" @click="saveProjectData()">Confirm</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="estimated_completed_date_popup" max-width="350" persistent>
      <v-card>
        <v-card-title class="headline">Confirmation</v-card-title>
        <v-card-text style="font-weight: 500;">
          <b>Estimation Completed Date field is required when Order is confirmed.You have to deactive order confirm option and then you can select Date.</b>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="error" @click="estimated_completed_date_popup = false;">Cancel</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="project_assign_group_popup" max-width="350" persistent>
      <v-card>
        <v-card-title class="headline">Confirmation</v-card-title>
        <v-card-text style="font-weight: 500;">
          <b>You can not change Project type as you have already assigned group in transaction.</b>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="error" @click="project_assign_group_popup = false;">Cancel</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-dialog>
</template>

<script>
import axios from "../../plugins/axios";
import { mapState, mapMutations } from "vuex";
import { getTotalOrderAmountwithAllcalculation } from "../../plugins/helper";
const moment = require("moment");
export default {
  name: "ProjectAdd",
  data() {
    return {
      loading: false,
      // customer_multiplier: '',
      disable_project_work_radio: false,
      form_data: {
        p_active: false,
        p_lock: false,
        profit_loss: true,
        // project_for_report: true,
        is_retainage: false,
        p_zip: "",
        bill_to_zip: "",
        mobile: "",
        work_phone: "",
        work_fax: "",
        project_work: "",
        p_type: null,
        p_code: "",
        access_to: [],
        bill_to_address_1: null,
        bill_to_address_2: null,
        multiplier: "",
        order_confirmed: false,
        display_date: null
      },
      locked: false,
      dateFormattedDisplay: null,
      customer_list: [],
      is_edit_view: false,
      estimated_completed_date: false,
      display_date: false,
      keyword_dialog: false,
      keyword_loading: false,
      bill_to_city_search: null,
      city_search: null,
      domain_search: null,
      zip_search: null,
      bill_zip_search: null,
      zip_loading: false,
      bill_zip_loading: false,
      new_zip_id: null,
      users: [],
      is_same_address: false,
      zip_items: [],
      domain_list: [],
      bill_cities: [],
      form_error: {},
      state_list: [],
      bill_zip_items: [],
      cities: [],
      exist_overhandvalue: "",
      exist_p_type: "",
      overhand_confirm: false,
      overhand_loading: false,
      project_work_value: "",
      overhand_project_work_value: "",
      original_project_work_value: "",
      next_overhand_project_work_value: "",
      last_change_order: "",
      dateFormatted: null,
      estimated_completed_date_popup: false,
      project_assign_group_popup: false,
      p_hold: [
        { text: "Yes", value: "yes" },
        { text: "No", value: "no" },
        { text: "Auto Freeze", value: "auto_freeze" }
      ],
      p_type: [
        { text: "Fixed Price", value: "fixed" },
        { text: "Cost Plus", value: "cost_plus" }
        // { text: "Project Management", value: "project_management" },
      ],
      order_types: [
        { text: "Order", value: "1" },
        { text: "Estimate", value: "2" }
        // { text: "EstToOrd", value: "3" },
        // { text: "Outstading", value: "4" },
        // { text: "Open Orders", value: "5" },
        // { text: "Canceled Estimates", value: "6" },
        // { text: "Canceled Orders", value: "7" },
        // { text: "Customer Refund", value: "8" },
      ]
    };
  },
  components: {},
  watch: {
    edit_modal: {
      handler(val) {
        if (val) {
          this.getStates(false);
          this.getStates(true);
          //this.getProject();
          this.getCustomers();
          this.getEmailDomains();
          //this.fetchBZipCodes();
          this.getUsers();
          this.disable_project_work_radio = false;
          this.getProject();
        }
      }
    },
    "form_data.p_zip": {
      handler() {
        this.getStates(false);
      }
    },
    "form_data.bill_to_zip": {
      handler() {
        this.getStates(true);
      }
    }
  },
  computed: {
    ...mapState("project", ["edit_modal", "id", "is_view_mode"]),
    lockName() {
      let _self = this;
      let last_change_order = _self.last_change_order;
      if (last_change_order == 0) {
        return "SO";
      } else {
        return "CO - " + last_change_order;
      }
    },
    sort_list() {
      let selected_vendors = this.form_data.access_to;
      let vendors = this.users.filter(item => {
        if (selected_vendors) {
          if (!selected_vendors.includes(item.user_id)) {
            return item;
          }
        } else {
          return item;
        }
      });
      vendors = vendors.sort((a, b) => {
        let fa = a.full_name,
          fb = b.full_name;
        if (fa < fb) {
          return -1;
        }
        if (fa > fb) {
          return 1;
        }
        return 0;
      });
      this.users.filter(item => {
        if (selected_vendors) {
          if (selected_vendors.includes(item.user_id)) {
            vendors.unshift(item);
          }
        }
      });
      return vendors;
    },
    selected_multi_values() {
      let return_data = "";
      if (this.form_data.access_to.length > 0) {
        this.users.filter(item => {
          if (item.user_id == this.form_data.access_to[0]) {
            return_data = item.full_name;
          }
        });
        if (this.form_data.access_to.length > 1) {
          let totalVen = this.form_data.access_to.length - 1;
          return_data = return_data + " (" + totalVen + " More)";
        }
      }
      return return_data;
    }
    // project_work() {
    //   console.log(this.form_data.project_work)
    //   return this.form_data.project_work.map(function (item) {
    //    return item.project_work;
    //   });
    // }
  },
  methods: {
    ...mapMutations("utils", ["setAlert"]),
    ...mapMutations("project", ["setData"]),
    closePopup() {
      this.setData({ key: "edit_modal", value: false });
    },
    parseDateDisplay() {
      const [year, month, day] = this.dateFormattedDisplay.split("-");
      this.form_data.display_date = `${month.padStart(2, "0")}/${day.padStart(
        2,
        "0"
      )}/${year}`;
    },
    changeStatus(type) {
      let _self = this;
      if (type == 1) {
        _self.locked = false;
        // _self.form_data.display_date = moment(new Date()).format("MM/DD/YYYY");
      } else {
        _self.locked = true;
      }
    },
    getUsers() {
      let _self = this;
      axios
        .get("user_list?itemsPerPage=-1")
        .then(response => {
          if (response.data.status) {
            _self.users = response.data.data.data;
          }
        })
        .catch(function() {});
    },
    parseDate() {
      const [year, month, day] = this.dateFormatted.split("-");
      this.form_data.estimated_completed_date = `${month.padStart(
        2,
        "0"
      )}/${day.padStart(2, "0")}/${year}`;
    },
    addCustomer() {
      this.$router.push({ path: "/customers" });
    },
    addUser() {
      this.$router.push({ path: "/users" });
    },
    sameAsAbove() {
      if (this.is_same_address) {
        this.loading = true;
        this.bill_zip_items = this.zip_items;
        this.bill_cities = this.cities;
        this.form_data.bill_to_zip = this.form_data.p_zip;
        this.form_data.bill_to_state = this.form_data.p_state;
        this.form_data.bill_to_city = this.form_data.p_city;
        this.form_data.bill_to_address_1 = this.form_data.p_address_1;
        this.form_data.bill_to_address_2 = this.form_data.p_address_2;

        let selected_customer = this.customer_list.filter(item => {
          return item.customer_id == this.form_data.customer_id;
        })[0];
        if (selected_customer) {
          this.form_data.bill_to = selected_customer.full_name;
        } else {
          this.form_data.bill_to = "";
        }

        this.loading = false;
      }
    },
    addDomain() {
      this.loading = true;
      let _self = this;
      axios
        .post("add_domain", { domain: _self.domain_search })
        .then(function(res) {
          let data = res.data.data;
          _self.domain_list.push({ value: data.domain_id, text: data.domain });
          _self.form_data.bill_to_email_domain = data.domain_id;
          _self.loading = false;
        })
        .catch(function(error) {
          console.log("FAILURE!!", error);
          _self.loading = false;
        });
    },
    changeCustomer() {
      this.loading = true;
      let selected_customer = this.customer_list.filter(item => {
        return item.customer_id == this.form_data.customer_id;
      })[0];
      this.form_data.multiplier = selected_customer.multiplier;
      this.zip_search = selected_customer.zip;
      this.fetchZipCodes();
      if (selected_customer.state) {
        this.form_data.p_state = selected_customer.state.state_id;
      } else {
        this.form_data.p_state = null;
      }
      if (selected_customer.city) {
        this.form_data.p_city = selected_customer.city.city_id;
      } else {
        this.form_data.p_city = null;
      }
      this.form_data.p_address_1 = selected_customer.address_line_1;
      this.form_data.p_address_2 = selected_customer.address_line_2;
      this.form_data.mobile = selected_customer.mobile_number;
      this.form_data.work_phone = selected_customer.work_phone;
      this.form_data.work_fax = selected_customer.fax;
      this.form_data.p_zip = selected_customer.zip;
      this.form_data.bill_to_email = selected_customer.email;
      if (selected_customer.email_domain) {
        this.form_data.bill_to_email_domain =
          selected_customer.email_domain.domain_id;
      } else {
        this.form_data.bill_to_email_domain = null;
      }
      //this.form_data.bill_to = selected_customer.company_name
      this.loading = false;
    },
    addCity() {
      this.loading = true;
      let _self = this;
      axios
        .post("add_city", {
          state_id: _self.form_data.p_state,
          city_name: _self.city_search
        })
        .then(function(res) {
          let data = res.data.data;
          _self.cities.push({ value: data.value, text: data.text });
          _self.form_data.p_city = data.value;
          _self.changeCity();
          _self.loading = false;
        })
        .catch(function(error) {
          console.log("FAILURE!!", error);
          _self.loading = false;
        });
    },
    addCity2() {
      this.loading = true;
      let _self = this;
      axios
        .post("add_city", {
          state_id: _self.form_data.bill_to_state,
          city_name: _self.bill_to_city_search
        })
        .then(function(res) {
          let data = res.data.data;
          _self.bill_cities.push({ value: data.value, text: data.text });
          _self.form_data.bill_to_city = data.value;
          _self.changeCity2();
          _self.loading = false;
        })
        .catch(function(error) {
          console.log("FAILURE!!", error);
          _self.loading = false;
        });
    },
    fetchBZipCodes() {
      this.bill_zip_loading = true;
      axios
        .get("get_zip_suggestion?zip=" + this.bill_zip_search)
        .then(response => {
          if (response.data.status) {
            this.bill_zip_items = response.data.data;
          }
          this.bill_zip_loading = false;
        })
        .catch(function() {})
        .then(() => {
          console.log("ok");
          this.bill_zip_loading = false;
        });
    },
    addZip() {
      this.loading = true;
      let _self = this;
      axios
        .post("add_zip", { zip_code: _self.zip_search })
        .then(function(res) {
          let data = res.data.data;
          _self.zip_items.push({ value: data.value, text: data.text });
          _self.form_data.p_zip = data.value;
          _self.new_zip_id = data.value;
          _self.getStates(false);
          _self.loading = false;
        })
        .catch(function(error) {
          console.log("FAILURE!!", error);
          _self.loading = false;
        });
    },
    addZip2() {
      this.loading = true;
      let _self = this;
      axios
        .post("add_zip", { zip_code: _self.bill_zip_search })
        .then(function(res) {
          let data = res.data.data;
          _self.bill_zip_items.push({ value: data.value, text: data.text });
          _self.form_data.bill_to_zip = data.value;
          _self.new_zip_id2 = data.value;
          _self.getStates(true);
          _self.loading = false;
        })
        .catch(function(error) {
          console.log("FAILURE!!", error);
          _self.loading = false;
        });
    },
    changeCity() {
      if (this.form_data.p_zip == this.new_zip_id) {
        axios
          .post("zip_update", {
            state_id: this.form_data.p_state,
            zip_id: this.form_data.p_zip,
            city_id: this.form_data.p_city
          })
          .then(() => {})
          .catch(function() {});
      }

      this.zip_loading = true;
      axios
        .get("get_zip_by_city?city_id=" + this.form_data.p_city)
        .then(response => {
          if (response.data.status) {
            this.zip_items = response.data.data;
          }
        })
        .catch(function() {})
        .then(() => {
          this.zip_loading = false;
        });
    },
    changeCity2() {
      if (this.form_data.bill_to_zip == this.new_zip_id2) {
        axios
          .post("zip_update", {
            state_id: this.form_data.bill_to_state,
            zip_id: this.form_data.bill_to_zip,
            city_id: this.form_data.bill_to_city
          })
          .then(() => {})
          .catch(function() {});
      }

      this.bill_zip_loading = true;
      axios
        .get("get_zip_by_city?city_id=" + this.form_data.bill_to_city)
        .then(response => {
          if (response.data.status) {
            this.bill_zip_items = response.data.data;
          }
        })
        .catch(function() {})
        .then(() => {
          this.bill_zip_loading = false;
        });
    },
    saveProject() {
      let _self = this;

      if (
        (_self.form_data.estimated_completed_date == "" ||
          _self.form_data.estimated_completed_date == "null" ||
          _self.form_data.estimated_completed_date == null) &&
        _self.form_data.order_confirmed == true &&
        _self.form_data.order_type == 1
      ) {
        this.estimated_completed_date_popup = true;
      } else if (
        _self.exist_p_type != _self.form_data.p_type &&
        _self.form_data.assign_group > 0
      ) {
        this.project_assign_group_popup = true;
      } else if (
        _self.exist_overhandvalue != _self.form_data.p_price &&
        (_self.form_data.total_new_con > 0 ||
          _self.form_data.total_remodeling > 0 ||
          _self.form_data.total_retail_sale > 0 ||
          _self.form_data.total_countertop > 0 ||
          _self.form_data.total_pro_management > 0)
      ) {
        let next_overhand_project_work_value = getTotalOrderAmountwithAllcalculation(
          _self.form_data.p_price,
          _self.form_data.multiplier,
          _self.original_project_work_value
        );
        this.next_overhand_project_work_value = next_overhand_project_work_value;
        this.overhand_confirm = true;
      } else {
        this.saveProjectData();
      }
    },
    saveProjectData() {
      this.loading = true;
      let _self = this;
      this.form_error = {};
      let serverData = JSON.parse(JSON.stringify(this._data.form_data));
      axios
        .post("edit_project", serverData)
        .then(function(res) {
          _self.loading = false;
          let data = res.data;
          if (!data.status) {
            for (let key in data.errors) {
              _self.form_error[key] = data.errors[key][0];
            }
            if (data.state_id) {
              _self.getCity(false, data.city);
            }
            if (data.zip) {
              _self.zip_items.push({ text: data.zip, value: data.zip });
            }
          } else {
            _self.setData({ key: "edit_modal", value: false });
          }
        })
        .catch(function(error) {
          console.log("FAILURE!!", error);
          _self.loading = false;
        });
    },
    getProject() {
      this.loading = true;
      let _self = this;
      axios.get("get_project?id=" + this.id).then(function(res) {
        if (res.data.status) {
          let data = res.data.data;
          for (let key in data) {
            if (key == "project_work") {
              if (data[key] && data[key][0]) {
                _self.form_data[key] = data[key][0].project_work;
              } else {
                _self.form_data[key] = "";
              }
            } else if (key == "access_to") {
              if (data[key]) {
                let project_access_user = [];
                for (let key3 in data[key]) {
                  project_access_user.push(data[key][key3].user_id);
                }
                _self.form_data[key] = project_access_user;
              } else {
                _self.form_data[key] = [];
              }
            } else {
              _self.form_data[key] = data[key];
            }
          }
          if (data.p_zip) {
            _self.zip_items.push({ text: data.p_zip, value: data.p_zip });
          }
          if (data.bill_to_zip) {
            _self.bill_zip_items.push({
              text: data.bill_to_zip,
              value: data.bill_to_zip
            });
          }
          if (data.p_state) {
            _self.getCity(data.p_city);
          }
          if (
            _self.form_data.total_new_con > 0 ||
            _self.form_data.total_remodeling > 0 ||
            _self.form_data.total_retail_sale > 0 ||
            _self.form_data.total_countertop > 0 ||
            _self.form_data.total_pro_management > 0
          ) {
            _self.disable_project_work_radio = true;
            if (_self.form_data.total_new_con > 0) {
              _self.overhand_project_work_value = parseFloat(
                _self.form_data.total_new_con
              ).toFixed(2);
              _self.original_project_work_value =
                _self.form_data.total_new_con_without_over;
            } else if (_self.form_data.total_remodeling > 0) {
              _self.overhand_project_work_value = parseFloat(
                _self.form_data.total_remodeling
              ).toFixed(2);
              _self.original_project_work_value =
                _self.form_data.total_remodeling_without_over;
            } else if (_self.form_data.total_retail_sale > 0) {
              _self.overhand_project_work_value = parseFloat(
                _self.form_data.total_retail_sale
              ).toFixed(2);
              _self.original_project_work_value =
                _self.form_data.total_retail_sale_without_over;
            } else if (_self.form_data.total_countertop > 0) {
              _self.overhand_project_work_value = parseFloat(
                _self.form_data.total_countertop
              ).toFixed(2);
              _self.original_project_work_value =
                _self.form_data.total_countertop_without_over;
            }
          }
          _self.exist_overhandvalue = data.p_price;
          _self.exist_p_type = data.p_type;
          _self.last_change_order = data.last_change_order;
          _self.form_data.retainage_percentage =
            _self.form_data.retainage_percentage != null
              ? _self.form_data.retainage_percentage
              : 10;
          if (_self.form_data.estimated_completed_date == null) {
            _self.form_data.estimated_completed_date = moment(
              moment(_self.form_data.display_date, "MM/DD/YYYY").add(
                6,
                "months"
              )
            ).format("MM/DD/YYYY");
          }
          _self.changeStatus(_self.form_data.order_type);
        }
        _self.loading = false;
      });
    },
    getCity() {
      let _self = this;
      axios
        .get("get_city?state_id=" + this.form_data.p_state)
        .then(response => {
          if (response.data.status) {
            _self.cities = response.data.data;
          }
        })
        .catch(function() {});
    },
    getStates(forBill = false) {
      let _self = this;
      let zip = forBill ? this.form_data.bill_to_zip : this.form_data.p_zip;
      axios
        .get("get_states?zip=" + zip)
        .then(response => {
          if (response.data.status) {
            _self.state_list = response.data.data;
            //if (response.data.selection) {
            if (forBill) {
              this.bill_cities = response.data.selection.all_city;
              this.form_data.bill_to_state =
                response.data.selection.selected_state;
              this.form_data.bill_to_city =
                response.data.selection.selected_city;
            } else {
              this.cities = response.data.selection.all_city;
              this.form_data.p_state = response.data.selection.selected_state;
              this.form_data.p_city = response.data.selection.selected_city;
            }
            //}
          }
        })
        .catch(function() {});
    },
    fetchZipCodes() {
      this.zip_loading = true;
      axios
        .get("get_zip_suggestion?zip=" + this.zip_search)
        .then(response => {
          if (response.data.status) {
            this.zip_items = response.data.data;
          }
        })
        .catch(function() {})
        .then(() => {
          this.zip_loading = false;
        });
    },
    getCustomers() {
      let _self = this;
      axios
        .get("customer_list?itemsPerPage=-1")
        .then(response => {
          _self.customer_list = response.data.data.data;
          // _self.customer_multiplier = ''
          // _self.customer_list.filter((item) => {
          //   if(item.customer_id == _self.form_data.customer_id) {
          //     // _self.form_data.multiplier = item.multiplier
          //   }
          // });
          // console.log(_self.customer_list);
        })
        .catch(function() {});
    },
    getEmailDomains() {
      axios.get("get_domains").then(response => {
        if (response.data.status) {
          this.domain_list = response.data.data;
        }
      });
    },
    deleteKeyword(keyword) {
      this.keyword_loading = true;
      let _self = this;
      axios
        .post("delete_keyword", keyword)
        .then(response => {
          if (response.data.status) {
            _self.form_data.keywords = _self.form_data.keywords.filter(function(
              eKeyword
            ) {
              return eKeyword.keyword_id != keyword.keyword_id;
            });
          }
        })
        .catch(function() {})
        .then(function() {
          _self.keyword_loading = false;
        });
    },
    disabledTypeValue() {
      this.form_data.p_type = "";
      this.form_data.p_price = "";
    }
  },
  mounted: function() {}
};
</script>
<style>
.project-radio-margin .v-input--selection-controls__input {
  margin-right: 16px !important;
}
.lock-red {
  color: red;
  font-size: 22px;
  margin-top: 10px;
}
.lock-green {
  color: green;
  font-size: 22px;
  margin-top: 10px;
}
</style>